import React, { Component } from 'react';

import '../../css/views/Methode.css';
import ZigZag from '../../components/ZigZag';
import Showcase from '../../components/Showcase';

import imageGradient2 from '../../images/gradient-2.jpg';

import imagePhase1 from '../../images/phase-1.jpg';
import imagePhase2 from '../../images/phase-2.jpg';
import imagePhase3 from '../../images/phase-3.jpg';

class Methode extends Component {
  render() {
    return (
    <div className="methode inner-content-page">
        <section className="hero-unit">
            <div>
                <img src={imageGradient2} alt="" />
                <div>Une méthode agile<br /> et créatrice de valeur ajoutée</div>
            </div>
            <div>
                <p>
                    Notre ambition ? Vous accompagner dans votre <strong>transformation numérique</strong> et vos projets grâce à nos solutions intelligentes qui maximiseront vos performances. Pour cela, nous avons développé une <strong>méthode collaborative</strong> et apte à repenser vos actions tout en tenant compte de vos enjeux.
                </p>
                <p>
                    Cette méthode est <strong>créatrice de valeur</strong> pour vous et vos clients et se découpe en plusieurs phases :
                </p>
            </div>
        </section>

        <section className="page-content">
            <section className="phase">
                <h2>Phase #1</h2>
                <section className="bloc-texte">
                    <p>
                        Notre méthode comprend d'abord une phase d'apprentissage de votre métier et d'échanges en amont de tous les projets. Au cours de rendez-vous ou d'<strong>ateliers collaboratifs</strong>, nous échangeons sur votre métier, votre culture, votre secteur et votre marché afin d'identifier ensemble votre demande. Grâce à notre regard extérieur sur votre activité, <em>nous pouvons ainsi déterminer précisément vos objectifs et vos besoins</em>.
                    </p>
                    <p>
                        <span className="head-of-paragraph">Objectif :</span> vous aider à <strong>exprimer vos besoins</strong> et formuler votre demande à travers un cahier des charges aligné sur votre stratégie. Nos outils méthodologiques sont élaborés de manière <strong>sur-mesure</strong> en fonction des clients, des projets et des budgets.
                    </p>
                </section>
            </section>

            <img className="image-phase" src={imagePhase1} alt="" />

            <section className="phase">
                <h2>Phase #2</h2>
                <section className="bloc-texte">
                    <p>
                        La seconde phase comprend <em>la mise en place du projet et la conception de la solution</em>, que <strong>nous pilotons</strong> depuis la création graphique & le webdesign (UX / UI design - ergonomie web), jusqu'au développement numérique.
                    </p>
                </section>
            </section>

            <img className="image-phase" src={imagePhase2} alt="" />

            <section className="phase">
                <h2>Phase #3</h2>
                <section className="bloc-texte">
                    <p>
                        La dernière phase est dédiée à <strong>la formation</strong> à la solution que nous avons conçue pour vous. Notre travail s'inscrit dans <strong>une véritable démarche de qualité</strong> pour laquelle nous sommes régulièrement audités et reconnus par nos clients. Depuis maintenant 10 ans, <em>nous nous appliquons à respecter cette exigence créative et technique pour chacun des projets</em>.
                    </p>
                </section>
            </section>

            <img className="image-phase" src={imagePhase3} alt="" />

            <section className="bloc-texte">
                <ZigZag />
                <h2>Une méthode maîtrisée pour des projets réussis</h2>
                <ZigZag />
            </section>

            <Showcase />
        </section>
    </div>
    );
  }
}

export default Methode;



// WEBPACK FOOTER //
// ./src/views/methode/Methode.js